<template>
<!--    <div v-if="pageView === 'material'" style="width: 100%; height: 100%">-->
<!--        <searchMaterialComponent :keyword="keyword" :viewList="viewList" :viewName="'material'" @changeView="changeView" @go-shop="goShop"/>-->
<!--    </div>-->

<!--    <div v-if="pageView === 'shop'" style="width: 100%; height: 100%">-->
<!--        <searchShopComponent :keyword="keyword" :viewList="viewList" :viewName="'shop'" @changeView="changeView" @go-shop="goShop"/>-->
<!--    </div>-->

    <div class="full-screen-view" ref="searchMainDom">
        <div v-show="pageView === 'adv'" class="full-screen-view" style="overflow-x: hidden; overflow-y: auto">
            <div class="return-part">
<!--                <el-button-->
<!--                    @click="clickReturn"-->
<!--                    type="primary"-->
<!--                    tkey="搜索"-->
<!--                >-->
<!--                    {{i18n.tkey("lang_search_text")}}-->
<!--                </el-button>-->
                <SearchStyleButton
                    style="padding-right: 50%;"
                    @click="clickReturn"
                />
            </div>

            <AdvSearchComponent />

<!--            <el-row-->
<!--                :gutter="10"-->
<!--                v-if="advPartVisible"-->
<!--                class="adv-part-box"-->
<!--            >-->
<!--                <el-col-->
<!--                    :span="cols"-->
<!--                    v-for="(v, i) in advList"-->
<!--                    :key="v.id"-->
<!--                    style="margin-bottom: 10px"-->
<!--                >-->
<!--                    <div class="adv-record-box">-->
<!--                        <div class="title-box">-->
<!--                            <span>{{getCompanyname(v)}}</span>-->
<!--                        </div>-->

<!--                        <AdvIframe-->
<!--                            :width="advWidth"-->
<!--                            :height="advHeight"-->
<!--                            :videoUrl="v.addinfo2"-->
<!--                            v-if="myUtil.isNotEmpty(v.addinfo2) && myUtil.isEmpty(v.addinfo3)"-->
<!--                        />-->

<!--                        <AdvVideo-->
<!--                            :width="advWidth"-->
<!--                            :height="advHeight"-->
<!--                            :videoUrl="v.addinfo3"-->
<!--                            v-if="myUtil.isNotEmpty(v.addinfo3)"-->
<!--                        />-->
<!--                    </div>-->

<!--                </el-col>-->
<!--            </el-row>-->
        </div>

        <div v-if="pageView === 'total'" class="full-screen-view">
            <searchTotalComponent :keyword="keyword" :viewList="viewList" :viewName="'total'"
                                  :type="type"  @changeView="changeView" @go-shop="goShop"/>
        </div>
    </div>

</template>

<script setup>
import {getCurrentInstance, inject, onMounted, ref, toRef, onBeforeMount} from 'vue'
    import searchMaterialComponent from '@/components/phone/searchMaterialComponent.vue'
    import searchShopComponent from '@/components/phone/searchShopComponent.vue'
    import searchTotalComponent from '@/components/phone/searchTotalComponent.vue'
    import AdvIframe from "@/components/shopopee/promotion/advIframe.vue";
    import AdvVideo from "@/components/shopopee/promotion/advVideo.vue";
    import SearchStyleButton from "@/plugins/projectA/ui/searchStyleButton.vue";
    import AdvSearchComponent from "@/components/shopopee/adv/advSearchComponent.vue";
    import myUtil from "@/util/util";
    import {useUserinfo} from "@/stores/userinfo";
    import jobArrangementRecordApi from "@/request/jobArrangementRecordApi";

    const props = defineProps(['type'])
    const emits = defineEmits(['go-shop'])

    const i18n = inject("i18n")
    const { proxy } = getCurrentInstance();
    const userInfoRef = toRef(useUserinfo())

    const domWidth = ref(340)
    const pageView = ref("adv")
    //是否加載廣告
    const advPartVisible = ref(false)
    const keyword = ref("")
    const viewList = ref([
        // {
        //     key: i18n.tkey("lang_all"),
        //     value: "total"
        // },
        {
            key: i18n.tkey("lang_item_1"),
            value: "material"
        },
        {
            key: i18n.tkey("lang_shop_text_1"),
            value: "shop"
        }
    ])
    const cols = ref(12)
    // const advList = ref([])
    const advWidth = ref(320)
    const advHeight = ref(180)

    function changeView(str, key) {
        pageView.value = str
        keyword.value = key
    }

    function goShop(wa, siojournal, islandid) {
        emits("go-shop", wa, siojournal, islandid)
    }

    // function getAdvList(){
    //     const request = jobArrangementRecordApi.getCurrTimeRecord
    //     const params = request.getParams()
    //
    //     request.send(params, (res) => {
    //         if (res.code == 200){
    //             advList.value = res.detail
    //             advPartVisible.value = true
    //         }else{
    //             advPartVisible.value = false
    //             pageView.value = "total"
    //         }
    //     })
    //
    // }

    function getCompanyname(obj){
        let name = obj.companyname2

        if (myUtil.isEmpty(name) || userInfoRef.value.lang === "zh" || userInfoRef.value.lang === "szh"){
            name = obj.companyname
        }

        return name
    }

    function clickReturn(){
        advPartVisible.value = false
        pageView.value = "total"
    }

    onBeforeMount(() => {
        if (props.type === "material"||props.type === "agentmaterial"){
            advPartVisible.value = false
            pageView.value = "total"
        }
    })

    onMounted(() => {
        domWidth.value = proxy.$refs.searchMainDom.offsetWidth

        if (domWidth.value > 768){
            cols.value = 6
            advWidth.value = domWidth.value / 4 - 40
        }else{
            advWidth.value = domWidth.value / 2 - 40
        }

        advHeight.value = Math.floor(advWidth.value / 16 * 9)

        if (pageView.value === "adv"){
            // getAdvList()
        }
    })
</script>

<style scoped>

.full-screen-view {
    width: 100%;
    height: 100%;
}

.adv-part-box {
    width: 100%;
    box-sizing: border-box;
    margin-top: 10px;
    padding-left: 10px;
    padding-right: 10px;

}

.adv-record-box {
    padding-top: 10px;
    padding-bottom: 10px;
    border: 1px #EBEEF5 solid;
    box-sizing: border-box;
    border-radius: 5px;
}

.title-box {
    color: #606266;
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 10px;
    text-align: center;
}

.return-part {
    margin-top: 10px;
    margin-bottom: 10px;
    text-align: center;
}

</style>